import { useEffect, useRef, useState } from "react";
import Footer from "../../Components/Footer";
import Navbar2 from "../../Components/Navbar2";
import "../Delhi-Ielts/Delhi-ielts.css";
import { useSelector } from "react-redux";
import Loading from "../../Components/Loading";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { DetailsTest } from "../../Action/FreeClassAction";

export default function TestStatus() {
  const Mobile_Screen = window.innerWidth;
  const dispatch = useDispatch();

  const { id } = useParams();

  const TLAT = 0;

  const { loading, detTLAT, error } = useSelector((s) => s.DetailsTestReducer);

  useEffect(() => {
    dispatch(DetailsTest(id));
  }, [id]);

  return (
    <div>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>TLAT Test Status | Free IELTS & PTE Classes – Testifyi</title>

        <meta
          name="title"
          content="TLAT Test Status | Free IELTS & PTE Classes – Testifyi"
        />

        {/* <meta
          name="description"
          content="You have already taken the TLAT test. Contact Testifyi academic coordinators to continue your free IELTS and PTE live class journey."
        /> */}

        <meta
          name="keywords"
          content="TLAT test status, Testifyi TLAT test, free IELTS classes, free PTE classes, IELTS coaching, PTE coaching, Testifyi IELTS PTE"
        />

        {/* Canonical */}
        <link rel="canonical" href="https://testifyi.com/tlat-test-status" />

        {/* Robots */}
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />

        {/* Open Graph / Facebook */}
        <meta
          property="og:title"
          content="TLAT Test Status | Free IELTS & PTE Classes – Testifyi"
        />
        <meta
          property="og:description"
          content="You have already taken the TLAT test. Get in touch with Testifyi coordinators to proceed with free IELTS & PTE live classes."
        />
        <meta
          property="og:url"
          content="https://testifyi.com/tlat-test-status/:id"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://testifyi.com/assets/images/Banner.png"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="TLAT Test Status | Free IELTS & PTE Classes – Testifyi"
        />
        <meta
          name="twitter:description"
          content="You have already taken the TLAT test. Contact Testifyi to continue your free IELTS & PTE training."
        />
        <meta
          name="twitter:image"
          content="https://testifyi.com/assets/images/Banner.png"
        />

        {/* Viewport */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Language & Charset */}
        <meta httpEquiv="Content-Language" content="en" />
        <meta charSet="UTF-8" />

        {/* Theme Color */}
        <meta name="theme-color" content="#0A3AFF" />

        {/* Extra SEO */}
        <meta name="author" content="Testifyi" />
        <meta name="language" content="English" />
        <meta name="revisit-after" content="1 days" />
      </Helmet>

      {loading ? <Loading /> : ""}
      <Navbar2 />

      <div className="Delhi_Ielts Take_Test">
        {detTLAT && (detTLAT?.Result || detTLAT?.Result == 0 )? (
          <div class="contact-wrapper" style={{ paddingTop: "40px" }}>
            <div class="contact-card">
              <h1>You Already Have Taken the TLAT Test</h1>

              <h2>
                Continue Your <span>FREE IELTS & PTE Class Journey</span>
              </h2>

              <p class="subtitle">
                Your TLAT test details, including score and test date, are
                already recorded in our system. To proceed further and access
                the free live IELTS and PTE classes, please contact our academic
                coordinators using the details below.
              </p>

              <div class="info-box">
                <p>📝 TLAT Test: Taken</p>
                <p>📊 Score: {detTLAT?.Result}</p>
                <p>
                  📅 Test Date:{" "}
                  {detTLAT?.createdAt
                    ? new Date(detTLAT?.createdAt).toLocaleDateString("en-GB")
                    : "N/A"}
                </p>
              </div>

              <div class="contact-info">
                <div class="contact-item">
                  <span>📧</span>
                  <p>
                    <strong>Email</strong>
                    <br />
                    <a href="mailto:support@testifyi.com">
                      info@testifyi.com
                    </a>
                  </p>
                </div>

                <div class="contact-item">
                  <span>📞</span>
                  <p>
                    <strong>Mobile</strong>
                    <br />
                    <a href="tel:+919876543210">+91 98765 43210</a>
                  </p>
                </div>
              </div>

              <p class="note">
                * Our coordinators will assist you with batch availability,
                schedules, and the next steps for your free IELTS & PTE
                training.
              </p>
            </div>
          </div>
        ) : (
          <div class="eligibility-wrapper" style={{ paddingTop: "40px" }}>
            <div class="eligibility-card">
              <h1>🎉 Congratulations!</h1>
              <h2>
                You’re Eligible for a{" "}
                <span>FREE Testifyi IELTS & PTE Class</span>
              </h2>

              <p class="subtitle">
                Complete a short eligibility test and unlock your free live
                class.
              </p>

              <div class="test-details">
                <ul>
                  <li>
                    📝 <strong>TLAT Test</strong>
                  </li>
                  <li>⏱️ 15 Minutes Duration</li>
                  <li>❓ 30 Questions</li>
                  <li>🎯 2 Marks per Question</li>
                  <li>🚫 No Negative Marking</li>
                  <li>
                    ✅ Score <strong>30+</strong> to Get Enrolled in Live Class
                  </li>
                </ul>
              </div>

              <a
                href={`https://testifyi.com/T-LAT-acknowledge/${detTLAT?.AttendeeCode}`}
                class="start-btn"
              >
                Start TLAT Test
              </a>

              <p class="note">
                * Limited time free access for eligible students only
              </p>
            </div>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}
